import { jsx } from 'panel';
import { SpinnerEl } from 'common/components/spinner';
import { SvgIconEl } from 'common/components/svg-icon';
import { SpinnerColor } from '../spinner/types';
import { ButtonTheme, ButtonType } from './constants';
export function template() {
  const theme = this.attr("theme");
  const isPrimary = theme === ButtonTheme.Primary;
  const content = this.innerHTML.trim();
  const iconOnly = !content && !!this.attr("icon") || content.length === 1;
  const isDestructive = this.attr("type") === ButtonType.Destructive || this.attr("icon") === "trashcan";
  const isPressed = this.attr("pressed");
  const linkAttrs = Object.assign(Object.assign({}, this.attr("href") && {
    href: this.attr("href")
  }), this.attr("target") && {
    target: this.attr("target")
  });
  return jsx("a", {
    sel: '.mp-button-container',
    attrs: Object.assign(Object.assign({}, linkAttrs), {
      elref: "buttonContainer"
    }),
    class: {
      ["mp-button-".concat(theme)]: true,
      ["type-".concat(this.attr("type"))]: true,
      'type-destructive': isDestructive,
      'is-icon-only': iconOnly,
      'is-pressed': isPressed,
      'is-disabled': this.attr("disabled")
    }
  }, jsx("div", {
    sel: '.mp-button-animation-layer'
  }), jsx("div", {
    sel: '.mp-button-content'
  }, this.attr("icon") === "spinner" ? jsx(SpinnerEl, {
    key: 'button-spinner',
    attrs: {
      color: isPrimary ? SpinnerColor.White : SpinnerColor.Blue
    }
  }) : this.attr("icon") ? jsx(SvgIconEl, {
    key: 'button-icon',
    attrs: {
      icon: this.attr("icon")
    }
  }) : null, content ? jsx("slot", {
    sel: '.mp-button-content-text'
  }) : null));
}